import { dictionary } from "@/schemas/dictionary";

const network = dictionary;
export const readNetwork = network.readonly();
export const writeNetwork = network.omit({ id: true });
